import React from "react";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";

export default function Paginator({ currentPage, setCurrentPage, pageCount, pagesToDisplay }) {
  return (
    <ul className="paginator">
      <li>
        <button
          className="paginator-chevron"
          onClick={() => {
            currentPage >= 1 ? setCurrentPage((page) => page - 1) : null;
          }}
        >
          <ChevronLeft />
        </button>
      </li>
      {[...pagesToDisplay()].map((i) => (
        <li key={`page-${i}`}>
          <button
            onClick={() => setCurrentPage(i)}
            className={`paginator-item ${currentPage === i ? "selected" : ""}`}
          >
            {i + 1}
          </button>
        </li>
      ))}
      <li>
        <button
          className="paginator-chevron"
          onClick={() => {
            currentPage < pageCount.current - 1 ? setCurrentPage((page) => page + 1) : null;
          }}
        >
          <ChevronRight />
        </button>
      </li>
    </ul>
  );
}
